import { omit } from 'ramda';
import { COMPONENT_DSL_NAMES, COMPONENT_DSL_PROP_TYPES, COMPONENT_DSL_TYPES, MENU_GROUP_NAMES, COMPONENT_DSL_INSIDE_ONLY_TYPES, COMPONENT_DSL_RULES_INTERACTION_TYPES, STATE_SCOPES, STATE_TYPES, COMPONENT_DSL_CALLBACK_TYPES, } from '../../../constants';
import { visibleByCondition } from '../../common/commonPresentations';
import { commonComponentProps, commonFormFieldProps } from '../../common/commonProps';
import { BuilderComponentsRating } from '../../material-components/BuilderComponentsRating';
import { BuilderComponentsFormRatingSettings } from './BuilderComponentsFormRating.settings';
export const BuilderComponentsFormRating = {
    name: COMPONENT_DSL_NAMES.BuilderComponentsFormRating,
    displayName: 'Form Rating',
    icon: 'rating',
    type: COMPONENT_DSL_TYPES.reactImportComponent,
    componentListGroupName: MENU_GROUP_NAMES.form,
    source: {
        importName: '@builder/components',
        codeEngineImportName: 'shared/components',
        componentName: 'FormRating',
    },
    schema: {
        mainPropPath: {
            mainProp: 'Label',
        },
        parentContraints: [
            {
                type: COMPONENT_DSL_RULES_INTERACTION_TYPES.insideOnly,
                container: {
                    type: COMPONENT_DSL_INSIDE_ONLY_TYPES.anyAncestor,
                    name: COMPONENT_DSL_NAMES.BuilderComponentsForm,
                },
            },
        ],
        presentations: [visibleByCondition],
        predefineds: {
            states: [
                {
                    scope: STATE_SCOPES.local,
                    type: STATE_TYPES.number,
                    name: 'FormRating',
                    defaultValue: 1.0,
                },
            ],
            props: {
                fieldProps: {
                    name: '__FORM__.FormRating',
                },
                ratingProps: Object.assign(Object.assign({}, omit(['value', 'onChange'], BuilderComponentsRating.schema.props.ratingProps)), { value: '{{ __STATES__.FormRating.value }}', onChange: {
                        actionType: 'customCode',
                        args: {
                            code: '__STATES__.FormRating.setValue(value)',
                        },
                    }, defaultValue: 1.0, size: 'medium', disabled: false, highlightSelectedOnly: false, max: 5, precision: 1, readOnly: false }),
            },
        },
        props: Object.assign(Object.assign({}, commonComponentProps), { onChange: {
                type: COMPONENT_DSL_PROP_TYPES.action,
                body: COMPONENT_DSL_CALLBACK_TYPES.code,
                args: [
                    {
                        name: 'event',
                        path: [0],
                    },
                    {
                        name: 'value',
                        path: [1],
                    },
                ],
            }, onChangeActive: {
                type: COMPONENT_DSL_PROP_TYPES.action,
                body: COMPONENT_DSL_CALLBACK_TYPES.code,
                args: [
                    {
                        name: 'event',
                        path: [0],
                    },
                    {
                        name: 'value',
                        path: [1],
                    },
                ],
            }, value: { type: COMPONENT_DSL_PROP_TYPES.number }, ratingProps: {
                type: COMPONENT_DSL_PROP_TYPES.object,
                props: BuilderComponentsRating.schema.props,
            }, fieldProps: {
                type: COMPONENT_DSL_PROP_TYPES.object,
                props: commonFormFieldProps,
            } }),
    },
    settings: BuilderComponentsFormRatingSettings,
};
